/**
 * User-facing copy for the ReportHeader. Kept here (rather than inline in JSX)
 * so apostrophes live in plain JS string literals — no `&apos;` entity escaping
 * — and the strings are in one place to read / edit / localize.
 */
export const REPORT_HEADER_STRINGS = {
  EDIT_MODE_BADGE: "You're in edit mode",
  UPDATE_REPORT_CTA: 'Update report',
  EDIT_MODAL_HEADER: 'Name of custom report',
  EDIT_MODAL_SUBHEADER:
    "Give your report a unique name so it's easier to identify",
} as const;
